export const translations = {
  EN: {
    // Navigation
    HOME: "HOME",
    ABOUT_ME: "ABOUT ME",
    PROJECTS: "PROJECTS",
    CONTACT: "CONTACT",

    // Settings
    LANGUAGE: "LANGUAGE",
    THEME: "THEME",

    // Home
    CREATIVE: "CREATIVE",
    DESIGN: "DESIGN",
    CODE_AS_MAGIC: "CODE AS MAGIC",
    AS_A: "AS A",
    UNICORN: "UNICORN",

    // About
    ALIAS_SUBTITLE: "(YES, UNIMIA IS JUST AN ALIAS. SHOCKER, I KNOW.)",
    YEARS_OLD: "24 YEARS OLD",
    LOCATION: "SOLEDADE/RS - BRAZIL",
    ABOUT_TEXT:
      "My journey into development began during my Computer Science studies at the University of Passo Fundo (UPF), where I discovered my passion for bringing ideas to life through code. From 2018 to 2022, I worked as a Full Stack Web and Mobile Developer at UPF, developing applications for university use while honing my skills in programming, UI design, and database integration. What started as academic curiosity evolved into a professional path that has taken me from scientific research to software engineering at Automasul and now to front-end development at ExpertVision.\n\nWhat sets me apart is my comprehensive technical toolkit combined with a design-oriented mindset. I believe in the power of Clean Architecture, Clean Code, and SOLID principles, which guide my approach to every project. My expertise spans TypeScript, JavaScript, React.js, Next.js, Flutter, and C#, allowing me to adapt to various technical requirements. I don't just build functional software; I craft experiences that are intuitive, responsive, and visually appealing. My background in both front-end and back-end technologies allows me to see the complete picture—from database architecture to pixel-perfect interfaces—while my passion for UI/UX ensures the user experience is always at the forefront.\n\nBeyond the professional sphere, I'm an enthusiastic Linux user (Arch, by the way!), a fan of open-source projects, and someone who genuinely enjoys the problem-solving aspects of development. I find myself constantly experimenting with new technologies and approaches in my spare time. This curiosity drives me to stay ahead of trends and continuously improve my skill set. Whether it's exploring new frameworks, contributing to open-source projects, or diving into design tools like Figma, I approach each learning opportunity with enthusiasm.\n\nMy development process is collaborative, methodical, and results-oriented. I thrive in agile environments where I can participate in strategic discussions to understand business needs and propose innovative solutions. I start by deeply understanding the problem, sketch out solutions using tools like Figma, build incrementally following best practices, and continuously refine based on feedback. This iterative approach, combined with my analytical thinking and problem-solving skills, allows me to deliver high-quality software that not only meets but exceeds expectations. I believe in clean, maintainable code that stands the test of time, and I'm always looking for ways to optimize both performance and user experience.",
    HIRE_ME_ANYWAY:
      "(BUT PLEASE, STILL HIRE ME FOR FLUTTER AND .NET PROJECTS ANYWAY)",

    // Education Section
    EDUCATION: "EDUCATION",
    ACADEMIC_DEGREE: "ACADEMIC DEGREE",
    BACHELORS_DEGREE: "BACHELOR'S DEGREE IN COMPUTER SCIENCE",
    GRADUATION: "GRADUATION",
    COMPLEMENTARY_COURSES: "COMPLEMENTARY COURSES",

    // Skills Section
    SKILLS: "SKILLS",
    TECHNICAL_EXPERTISE: "TECHNICAL EXPERTISE",

    // Experience Section
    EXPERIENCE: "EXPERIENCE",
    PROFESSIONAL_JOURNEY: "PROFESSIONAL JOURNEY",
    SOFTWARE_ENGINEER: "SOFTWARE ENGINEER AT AUTOMASUL",
    ADMIN_ASSISTANT:
      "ADMINISTRATIVE ASSISTANT AT CENTRO TECNOLÓGICO DE PEDRAS, GEMAS E JOIAS DO RS",
    IT_TECHNICIAN: "IT TECHNICIAN AT J. S. SONTAG",
    SCHOLARSHIP: "SCIENTIFIC INITIATION SCHOLARSHIP PROGRAM",

    // Languages Section
    LANGUAGES: "LANGUAGES",
    COMMUNICATION: "COMMUNICATION",
    PORTUGUESE: "BRAZILIAN PORTUGUESE",
    ENGLISH: "ENGLISH",
    NATIVE: "NATIVE",
    FLUENT: "FLUENT",

    // Projects
    VIEW_PROJECT: "VIEW PROJECT",
    MORE_PROJECTS: "WANT TO SEE MORE PROJECTS?",
    NO_PROJECTS_YET:
      "I DON'T HAVE MORE PROJECTS TO SHOW IT YET, SO PLEASE HIRE ME SO I CAN HAVE MORE PROJECTS TO PUT IT HERE",
    IF_ALLOWED: "(if you allow it, of course)",
    VISIT_GITHUB: "VISIT MY GITHUB",

    // Contact
    YOUR_NAME: "YOUR NAME",
    YOUR_EMAIL: "YOUR EMAIL",
    YOUR_MESSAGE: "YOUR MESSAGE",
    SEND_MESSAGE: "SEND MESSAGE",
    OR_EMAIL_DIRECTLY: "OR SEND AN EMAIL DIRECTLY TO",

    // About Page - Experience Details
    EXPERIENCE_AUTOMASUL: "SOFTWARE ENGINEER AT AUTOMASUL",
    EXPERIENCE_AUTOMASUL_DATE: "JULY 2022 - AUGUST 2024",
    EXPERIENCE_AUTOMASUL_DETAILS: [
      "Developed and maintained internal tools using C# with .NET Framework, JavaScript with various frameworks and Flutter, enhancing operational efficiency and automating critical processes.",
      "Collaborated closely with cross-functional teams, including operations, technical support, and management, to define requirements, integrate new features, and optimize workflows.",
      "Actively participated in strategic meetings to understand business needs and propose innovative technological solutions to drive productivity.",
      "Applied technical skills in JavaScript, React.JS, NodeJS, Flutter, C#, .NET Framework, SQL Server, Figma, and WPF.",
    ],

    EXPERIENCE_CENTRO:
      "ADMINISTRATIVE ASSISTANT AT CENTRO TECNOLÓGICO DE PEDRAS, GEMAS E JOIAS DO RS",
    EXPERIENCE_CENTRO_DATE: "AUGUST 2021 - JUNE 2022",
    EXPERIENCE_CENTRO_DETAILS: [
      "Collaborated with design teams to create customized materials.",
    ],

    EXPERIENCE_SONTAG: "IT TECHNICIAN AT J. S. SONTAG",
    EXPERIENCE_SONTAG_DATE: "FEBRUARY 2021 - MAY 2021",
    EXPERIENCE_SONTAG_DETAILS: [
      "Maintained computer equipment and provided support for financial management software, enhancing operational efficiency.",
    ],

    EXPERIENCE_SCHOLARSHIP: "FULL STACK WEB AND MOBILE DEVELOPER AT UNIVERSITY OF PASSO FUNDO",
    EXPERIENCE_SCHOLARSHIP_DATE: "MARCH 2018 - FEBRUARY 2022",
    EXPERIENCE_SCHOLARSHIP_DETAILS: [
      "Developed mobile and web applications for university use, improving skills in programming, UI design, and database integration.",
      "Contributed to the creation of educational content, focusing on accessibility, usability, and user engagement.",
      "Refined problem-solving skills, team collaboration, and adaptability to new technologies.",
    ],

    EXPERIENCE_FREELANCE: "FREELANCE FULL-STACK DEVELOPER",
    EXPERIENCE_FREELANCE_DATE: "SEPTEMBER 2023 - PRESENT",
    EXPERIENCE_FREELANCE_DETAILS: [
      "Working as a freelance full-stack developer with a focus on front-end development.",
      "Creating responsive and interactive web applications using modern technologies.",
      "Collaborating with clients to deliver high-quality solutions that meet their needs.",
    ],

    EXPERIENCE_EXPERTVISION: "MID-LEVEL FRONT-END DEVELOPER AT EXPERTVISION",
    EXPERIENCE_EXPERTVISION_DATE: "JANUARY 2025 - PRESENT",
    EXPERIENCE_EXPERTVISION_DETAILS: [
      "Actively contribute to the development of large-scale web systems, ensuring scalability and efficiency for a substantial number of users.",
      "Design and implement intuitive and responsive user interfaces, providing a seamless user experience across multiple devices.",
      "Develop and optimize administrative dashboards to facilitate system management and operations, offering advanced analysis and control tools.",
      "Participate in agile development cycles, utilizing sprints to efficiently and continuously deliver features.",
      "Develop with TypeScript, JavaScript, React.JS, Next.JS, Axios, Figma, Firebase, and Django.",
    ],

    // About Page - Skills
    SKILLS_JAVASCRIPT: "JAVASCRIPT - ",
    SKILLS_JAVASCRIPT_DETAILS: "REACT.JS, NODE.JS, NEXT.JS AND TYPESCRIPT",
    SKILLS_CSHARP: "C# - ",
    SKILLS_CSHARP_DETAILS: ".NET CORE, .NET FRAMEWORK, WPF AND WINDOWS FORMS",
    SKILLS_MOBILE: "MOBILE - ",
    SKILLS_MOBILE_DETAILS: "FLUTTER",
    SKILLS_DATABASES: "DATABASES - ",
    SKILLS_DATABASES_DETAILS: "SQL, MONGODB AND FIREBASE",
    SKILLS_CLOUD: "CLOUD - ",
    SKILLS_CLOUD_DETAILS: "AWS, AZURE AND DOCKER",
    SKILLS_UIUX: "UI/UX DESIGN - ",
    SKILLS_UIUX_DETAILS: "ADOBE PHOTOSHOP, GIMP AND FIGMA",
    SKILLS_VERSION: "VERSION CONTROL - ",
    SKILLS_VERSION_DETAILS: "GIT",

    // About Page - Education
    EDUCATION_DEGREE:
      "BACHELOR'S DEGREE IN COMPUTER SCIENCE - UNIVERSIDADE DE PASSO FUNDO (UPF)",
    EDUCATION_GRADUATION: "GRADUATION: 2023",
    CLICK_ME: "CLICK ME!",

    // Projects Descriptions
    PROJECT_NATAN_TITLE: "NATAN TATTOO",
    PROJECT_NATAN_DESC:
      "A modern landing page for a tattoo artist, showcasing their work and providing an easy way for clients to get in touch.",

    PROJECT_PORTFOLIO_TITLE: "UNIMIA PORTFOLIO",
    PROJECT_PORTFOLIO_DESC:
      "A personal portfolio website featuring smooth animations and a responsive design that works seamlessly across all devices.",

    NOTIFICATIONS: "NOTIFICATIONS",
    CLEAR_ALL: "CLEAR ALL",
    NO_NOTIFICATIONS: "NO NEW NOTIFICATIONS",
    WELCOME_NOTIFICATION_TITLE: "WELCOME TO MY PORTFOLIO!",
    WELCOME_NOTIFICATION_WINDOWS:
      "I see you're a Windows user! That's great - I have even worked on building Windows applications before, but... have you ever heard of the Linux initiative?",
    WELCOME_NOTIFICATION_MACOS:
      "Hello, Mac user! As a developer who appreciates clean design, I'm sure you'll enjoy my (sometimes) minimalist approach to web development.",
    WELCOME_NOTIFICATION_LINUX:
      "A Linux user! I love Linux. Linux is great. Just as great as this portfolio. (I use Arch BTW)",
    WELCOME_NOTIFICATION_IOS:
      "Welcome, iOS user! I develop cross-platform mobile apps too using Flutter, so feel free to hire me for your next project!",
    WELCOME_NOTIFICATION_IPAD:
      "Perfect timing - this portfolio looks amazing on iPad! The larger screen really brings out the animations.",
    WELCOME_NOTIFICATION_ANDROID:
      "Welcome, Android user! The superior mobile OS! I develop cross-platform mobile apps too using Flutter, so feel free to hire me for your next project!",
    WELCOME_NOTIFICATION_DEFAULT:
      "Welcome to my portfolio! Feel free to explore my work and get in touch if you'd like to collaborate on a project!",
    TIME_NOTIFICATION_TITLE: "STILL HERE? LET'S WORK TOGETHER!",
    TIME_NOTIFICATION_MESSAGE:
      "I see you've been exploring my portfolio for a while now. If you're interested in working together, why not head over to the Contact page and drop me a message? I'd love to hear about your project!",
    WELCOME_TITLE: "Welcome to My Portfolio!",
    WELCOME_LANGUAGE: "Choose Your Language",
    WELCOME_THEME: "Choose Your Theme",
    WELCOME_INFO:
      "You can change these settings anytime by clicking the settings icon in the top right corner.",
    WELCOME_CONTINUE: "Continue",
    DEVELOPER_TITLE: "FULL-STACK DEVELOPER",
    CLOSED_SOURCE_PROJECTS: "CLOSED SOURCE PROJECTS",
    OPEN_SOURCE_PROJECTS: "OPEN SOURCE PROJECTS",
    PROJECT_SEUCURSO_TITLE: "SEU CURSO DIGITAL",
    PROJECT_SEUCURSO_DESC:
      "Web and mobile learning platform offering free courses in Portuguese.",
    PROJECT_BEHARV_TITLE: "BEHARV",
    PROJECT_BEHARV_DESC:
      "Web and mobile learning platform offering free courses in English and Spanish.",
    PROJECT_LARHHUB_TITLE: "LARHUB",
    PROJECT_LARHHUB_DESC: "Web platform for real estate management.",
    PROJECT_EXPERTVISION_TITLE: "EXPERTVISION",
    PROJECT_EXPERTVISION_DESC:
      "A modern and responsive website for Expert Vision, a technology solutions company.",
  },
  "PT-BR": {
    // Navigation
    HOME: "INÍCIO",
    ABOUT_ME: "SOBRE MIM",
    PROJECTS: "PROJETOS",
    CONTACT: "CONTATO",

    // Settings
    LANGUAGE: "IDIOMA",
    THEME: "TEMA",

    // Home
    CREATIVE: "DESIGN",
    DESIGN: "CRIATIVO",
    CODE_AS_MAGIC: "CÓDIGO TÃO MÁGICO",
    AS_A: "QUANTO UM",
    UNICORN: "UNICÓRNIO",

    // About
    ALIAS_SUBTITLE: "(SIM, UNIMIA É SÓ UM APELIDO. SURPREENDENTE, EU SEI.)",
    YEARS_OLD: "24 ANOS",
    LOCATION: "SOLEDADE/RS - BRASIL",
    ABOUT_TEXT:
      "Minha jornada no desenvolvimento começou durante meus estudos em Ciência da Computação na Universidade de Passo Fundo (UPF), onde descobri minha paixão por dar vida às ideias através do código. De 2018 a 2022, trabalhei como Desenvolvedor Full Stack Web e Mobile na UPF, criando aplicações para uso universitário enquanto aprimorava minhas habilidades em programação, design de interface e integração de banco de dados. O que começou como curiosidade acadêmica evoluiu para um caminho profissional que me levou da pesquisa científica à engenharia de software na Automasul e agora ao desenvolvimento front-end na ExpertVision.\n\nO que me diferencia é meu conjunto abrangente de ferramentas técnicas combinado com uma mentalidade orientada ao design. Acredito no poder da Clean Architecture, Clean Code e princípios SOLID, que norteiam minha abordagem em cada projeto. Minha expertise abrange TypeScript, JavaScript, React.js, Next.js, Flutter e C#, permitindo-me adaptar a diversos requisitos técnicos. Não apenas construo software funcional; crio experiências que são intuitivas, responsivas e visualmente atraentes. Minha experiência em tecnologias front-end e back-end me permite ver o quadro completo—da arquitetura de banco de dados a interfaces com perfeitos detalhes—enquanto minha paixão por UI/UX garante que a experiência do usuário esteja sempre em primeiro plano.\n\nAlém da esfera profissional, sou um usuário entusiasta de Linux (Arch, a propósito!), fã de projetos open-source e alguém que genuinamente aprecia os aspectos de resolução de problemas do desenvolvimento. Estou constantemente experimentando novas tecnologias e abordagens em meu tempo livre. Esta curiosidade me motiva a estar à frente das tendências e a melhorar continuamente meu conjunto de habilidades. Seja explorando novos frameworks, contribuindo para projetos de código aberto ou me aprofundando em ferramentas de design como Figma, abordo cada oportunidade de aprendizado com entusiasmo.\n\nMeu processo de desenvolvimento é colaborativo, metódico e orientado a resultados. Prospero em ambientes ágeis onde posso participar de discussões estratégicas para entender as necessidades do negócio e propor soluções inovadoras. Começo entendendo profundamente o problema, esboço soluções usando ferramentas como Figma, construo incrementalmente seguindo as melhores práticas e refino continuamente com base em feedback. Esta abordagem iterativa, combinada com meu pensamento analítico e habilidades de resolução de problemas, me permite entregar software de alta qualidade que não apenas atende, mas excede as expectativas. Acredito em código limpo e manutenível que resiste ao teste do tempo, e estou sempre buscando maneiras de otimizar tanto o desempenho quanto a experiência do usuário.",
    HIRE_ME_ANYWAY:
      "(MAS POR FAVOR, ME CONTRATE PARA PROJETOS EM FLUTTER E .NET MESMO ASSIM)",

    // Education Section
    EDUCATION: "EDUCAÇÃO",
    ACADEMIC_DEGREE: "FORMAÇÃO ACADÊMICA",
    BACHELORS_DEGREE: "BACHARELADO EM CIÊNCIA DA COMPUTAÇÃO",
    GRADUATION: "FORMATURA",
    COMPLEMENTARY_COURSES: "CURSOS COMPLEMENTARES",

    // Skills Section
    SKILLS: "HABILIDADES",
    TECHNICAL_EXPERTISE: "CONHECIMENTOS TÉCNICOS",

    // Experience Section
    EXPERIENCE: "EXPERIÊNCIA",
    PROFESSIONAL_JOURNEY: "JORNADA PROFISSIONAL",
    SOFTWARE_ENGINEER: "ENGENHEIRO DE SOFTWARE NA AUTOMASUL",
    ADMIN_ASSISTANT:
      "ASSISTENTE ADMINISTRATIVO NO CENTRO TECNOLÓGICO DE PEDRAS, GEMAS E JOIAS DO RS",
    IT_TECHNICIAN: "TÉCNICO DE TI NA J. S. SONTAG",
    SCHOLARSHIP: "BOLSISTA DE INICIAÇÃO CIENTÍFICA",

    // Languages Section
    LANGUAGES: "IDIOMAS",
    COMMUNICATION: "COMUNICAÇÃO",
    PORTUGUESE: "PORTUGUÊS BRASILEIRO",
    ENGLISH: "INGLÊS",
    NATIVE: "NATIVO",
    FLUENT: "FLUENTE",

    // Projects
    VIEW_PROJECT: "VER PROJETO",
    MORE_PROJECTS: "QUER VER MAIS PROJETOS?",
    NO_PROJECTS_YET:
      "EU AINDA NÃO TENHO MAIS PROJETOS PARA MOSTRAR, ENTÃO POR FAVOR ME CONTRATE PARA QUE EU POSSA TER MAIS PROJETOS PARA COLOCAR AQUI",
    IF_ALLOWED: "(se você permitir, claro)",
    VISIT_GITHUB: "VISITE MEU GITHUB",

    // Contact
    YOUR_NAME: "SEU NOME",
    YOUR_EMAIL: "SEU EMAIL",
    YOUR_MESSAGE: "SUA MENSAGEM",
    SEND_MESSAGE: "ENVIAR MENSAGEM",
    OR_EMAIL_DIRECTLY: "OU ENVIE UM EMAIL DIRETAMENTE PARA",

    // About Page - Experience Details
    EXPERIENCE_AUTOMASUL: "ENGENHEIRO DE SOFTWARE NA AUTOMASUL",
    EXPERIENCE_AUTOMASUL_DATE: "JULHO 2022 - AGOSTO 2024",
    EXPERIENCE_AUTOMASUL_DETAILS: [
      "Desenvolvi e mantive ferramentas internas usando C# com .NET Framework, JavaScript com vários frameworks e Flutter, aprimorando a eficiência operacional e automatizando processos críticos.",
      "Colaborei de perto com equipes multifuncionais, incluindo operações, suporte técnico e gestão, para definir requisitos, integrar novos recursos e otimizar fluxos de trabalho.",
      "Participei ativamente de reuniões estratégicas para entender as necessidades de negócio e propor soluções tecnológicas inovadoras para impulsionar a produtividade.",
      "Apliquei habilidades técnicas em JavaScript, React.JS, NodeJS, Flutter, C#, .NET Framework, SQL Server, Figma e WPF.",
    ],

    EXPERIENCE_CENTRO:
      "ASSISTENTE ADMINISTRATIVO NO CENTRO TECNOLÓGICO DE PEDRAS, GEMAS E JOIAS DO RS",
    EXPERIENCE_CENTRO_DATE: "AGOSTO 2021 - JUNHO 2022",
    EXPERIENCE_CENTRO_DETAILS: [
      "Colaborei com equipes de design para criar materiais personalizados.",
    ],

    EXPERIENCE_SONTAG: "TÉCNICO DE TI NA J. S. SONTAG",
    EXPERIENCE_SONTAG_DATE: "FEVEREIRO 2021 - MAIO 2021",
    EXPERIENCE_SONTAG_DETAILS: [
      "Mantive equipamentos de informática e forneci suporte para software de gestão financeira, melhorando a eficiência operacional.",
    ],

    EXPERIENCE_SCHOLARSHIP: "DESENVOLVEDOR FULL STACK WEB E MOBILE NA UNIVERSIDADE DE PASSO FUNDO",
    EXPERIENCE_SCHOLARSHIP_DATE: "MARÇO 2018 - FEVEREIRO 2022",
    EXPERIENCE_SCHOLARSHIP_DETAILS: [
      "Desenvolvi aplicações móveis e web para uso universitário, aprimorando habilidades em programação, design de interface e integração de banco de dados.",
      "Contribuí para a criação de conteúdo educacional, com foco em acessibilidade, usabilidade e engajamento do usuário.",
      "Refinei habilidades de resolução de problemas, colaboração em equipe e adaptabilidade a novas tecnologias.",
    ],

    EXPERIENCE_FREELANCE: "DESENVOLVEDOR FULL-STACK FREELANCE",
    EXPERIENCE_FREELANCE_DATE: "SETEMBRO 2023 - ATUAL",
    EXPERIENCE_FREELANCE_DETAILS: [
      "Trabalhando como desenvolvedor full-stack freelance com foco em desenvolvimento front-end.",
      "Criando aplicações web responsivas e interativas usando tecnologias modernas.",
      "Colaborando com clientes para entregar soluções de alta qualidade que atendam suas necessidades.",
    ],

    EXPERIENCE_EXPERTVISION: "DESENVOLVEDOR FRONT-END PLÊNO NA EXPERTVISION",
    EXPERIENCE_EXPERTVISION_DATE: "JANEIRO 2025 - ATUAL",
    EXPERIENCE_EXPERTVISION_DETAILS: [
      "Contribuo ativamente para o desenvolvimento de sistemas web de grande escala, garantindo escalabilidade e eficiência para um número substancial de usuários.",
      "Projeto e implemento interfaces de usuário intuitivas e responsivas, proporcionando uma experiência perfeita em múltiplos dispositivos.",
      "Desenvolvo e otimizo paineis administrativos para facilitar o gerenciamento e operações do sistema, oferecendo ferramentas avançadas de análise e controle.",
      "Participo de ciclos de desenvolvimento ágil, utilizando sprints para entregar recursos de forma eficiente e contínua.",
      "Desenvolvo com TypeScript, JavaScript, React.JS, Next.JS, Axios, Figma, Firebase e Django.",
    ],

    // About Page - Skills
    SKILLS_JAVASCRIPT: "JAVASCRIPT - ",
    SKILLS_JAVASCRIPT_DETAILS: "REACT.JS, NODE.JS, NEXT.JS E TYPESCRIPT",
    SKILLS_CSHARP: "C# - ",
    SKILLS_CSHARP_DETAILS: ".NET CORE, .NET FRAMEWORK, WPF E WINDOWS FORMS",
    SKILLS_MOBILE: "MOBILE - ",
    SKILLS_MOBILE_DETAILS: "FLUTTER",
    SKILLS_DATABASES: "BANCO DE DADOS - ",
    SKILLS_DATABASES_DETAILS: "SQL, MONGODB E FIREBASE",
    SKILLS_CLOUD: "CLOUD - ",
    SKILLS_CLOUD_DETAILS: "AWS, AZURE E DOCKER",
    SKILLS_UIUX: "UI/UX DESIGN - ",
    SKILLS_UIUX_DETAILS: "ADOBE PHOTOSHOP, GIMP E FIGMA",
    SKILLS_VERSION: "CONTROLE DE VERSÃO - ",
    SKILLS_VERSION_DETAILS: "GIT",

    // About Page - Education
    EDUCATION_DEGREE:
      "BACHARELADO EM CIÊNCIA DA COMPUTAÇÃO - UNIVERSIDADE DE PASSO FUNDO (UPF)",
    EDUCATION_GRADUATION: "FORMATURA: 2023",
    CLICK_ME: "CLIQUE AQUI!",

    // Projects Descriptions
    PROJECT_NATAN_TITLE: "NATAN TATTOO",
    PROJECT_NATAN_DESC:
      "Uma landing page moderna para um tatuador, mostrando seus trabalhos e fornecendo uma maneira fácil para os clientes entrarem em contato.",

    PROJECT_PORTFOLIO_TITLE: "PORTFÓLIO UNIMIA",
    PROJECT_PORTFOLIO_DESC:
      "Um site de portfólio pessoal com animações suaves e design responsivo que funciona perfeitamente em todos os dispositivos.",

    NOTIFICATIONS: "NOTIFICAÇÕES",
    CLEAR_ALL: "LIMPAR TUDO",
    NO_NOTIFICATIONS: "NENHUMA NOTIFICAÇÃO NOVA",
    WELCOME_NOTIFICATION_TITLE: "BEM-VINDO AO MEU PORTFÓLIO!",
    WELCOME_NOTIFICATION_WINDOWS:
      "Vejo que você usa Windows! Ótimo - eu já trabalhei em aplicações Windows, mas... você já ouviu falar em Linux?",
    WELCOME_NOTIFICATION_MACOS:
      "Olá, usuário Mac! Como desenvolvedor que aprecia design limpo, tenho certeza que você vai gostar da minha abordagem (talvez) minimalista para desenvolvimento web.",
    WELCOME_NOTIFICATION_LINUX:
      "Um usuário Linux! Eu amo Linux. Linux é ótimo. Tão bom quanto este portfólio. (Eu uso Arch BTW)",
    WELCOME_NOTIFICATION_IOS:
      "Bem-vindo, usuário iOS! Eu também desenvolvo aplicativos mobile multiplataforma usando Flutter, então não hesite em me contratar para o seu próximo projeto!",
    WELCOME_NOTIFICATION_IPAD:
      "Momento perfeito - este portfólio fica incrível no iPad! A tela maior realmente destaca as animações.",
    WELCOME_NOTIFICATION_ANDROID:
      "Bem-vindo, usuário Android! O sistema operacional superior! Eu também desenvolvo aplicativos mobile multiplataforma usando Flutter, então não hesite em me contratar para o seu próximo projeto!",
    WELCOME_NOTIFICATION_DEFAULT:
      "Bem-vindo ao meu portfólio! Fique à vontade para explorar meu trabalho e entrar em contato se quiser colaborar em um projeto!",
    TIME_NOTIFICATION_TITLE: "AINDA POR AQUI? VAMOS TRABALHAR JUNTOS!",
    TIME_NOTIFICATION_MESSAGE:
      "Vejo que você está explorando meu portfólio há algum tempo. Se você está interessado em trabalharmos juntos, que tal ir até a página de Contato e me mandar uma mensagem? Adoraria ouvir sobre seu projeto!",
    WELCOME_TITLE: "Bem-vindo ao Meu Portfólio!",
    WELCOME_LANGUAGE: "Escolha seu Idioma",
    WELCOME_THEME: "Escolha seu Tema",
    WELCOME_INFO:
      "Você pode alterar essas configurações a qualquer momento clicando no ícone de configurações no canto superior direito.",
    WELCOME_CONTINUE: "Continuar",
    DEVELOPER_TITLE: "DESENVOLVEDOR FULL-STACK",
    CLOSED_SOURCE_PROJECTS: "PROJETOS DE CÓDIGO FECHADO",
    OPEN_SOURCE_PROJECTS: "PROJETOS DE CÓDIGO ABERTO",
    PROJECT_SEUCURSO_TITLE: "SEU CURSO DIGITAL",
    PROJECT_SEUCURSO_DESC:
      "Plataforma web e mobile de ensino que oferece cursos gratuitos na língua portuguesa.",
    PROJECT_BEHARV_TITLE: "BEHARV",
    PROJECT_BEHARV_DESC:
      "Plataforma web e mobile de ensino que oferece cursos gratuitos na língua inglesa e espanhola.",
    PROJECT_LARHHUB_TITLE: "LARHUB",
    PROJECT_LARHHUB_DESC: "Plataforma web de gerenciamento imobiliário.",
    PROJECT_EXPERTVISION_TITLE: "EXPERTVISION",
    PROJECT_EXPERTVISION_DESC:
      "Um website moderno e responsivo para a Expert Vision, uma empresa de soluções tecnológicas.",
  },
};
